import { render, staticRenderFns } from "./weeklySpending.vue?vue&type=template&id=52509a2d&scoped=true"
import script from "./weeklySpending.vue?vue&type=script&lang=js"
export * from "./weeklySpending.vue?vue&type=script&lang=js"
import style0 from "./weeklySpending.vue?vue&type=style&index=0&id=52509a2d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52509a2d",
  null
  
)

export default component.exports